import { render, staticRenderFns } from "./PopupEditVenueNotes.vue?vue&type=template&id=3915cd2e&scoped=true&"
import script from "./PopupEditVenueNotes.vue?vue&type=script&lang=js&"
export * from "./PopupEditVenueNotes.vue?vue&type=script&lang=js&"
import style0 from "./PopupEditVenueNotes.vue?vue&type=style&index=0&id=3915cd2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3915cd2e",
  null
  
)

export default component.exports